import React from 'react';
import clsx from 'clsx';

const AccessoryDropdownItem = ({ active, value }) => {    
    const { image, url, itemName } = value;
    
    const imageContainerClassName = clsx({
        'product-detail__dropdown-item-image-container': true,
        'product-detail__dropdown-item-image-container--empty': !image.url,
    });
    
    const children = (<>
        <span className={imageContainerClassName}>
            {image.url && (
                <img src={image.url}
                     alt={image.alt}
                     className="product-detail__dropdown-item-image"/>
            )}
        </span>
        <span className="product-detail__dropdown-item-text-container">
            <p className="product-detail__dropdown-item-title">
                {itemName}
            </p>
        </span>
        <span className="product-detail__dropdown-item-check-icon-container">
            {active && (
                <img src="/ui/images/checked.svg"
                     alt=""
                     className="product-detail__dropdown-item-check-icon"/>
            )}
        </span>
    </>);
    
    
    if (url) {
        return (
            <a href={url}
               className="product-detail__dropdown-menu-item-container">
                {children}
            </a>
        );      
    }    
    
    return (
        <span className="product-detail__dropdown-menu-item-container">
            {children}
        </span>
    );
};

export default AccessoryDropdownItem;
